<template>
    <div class="rkld">
        <div class="rkldRight">
            <div class="rkldRightContent">
                <el-tabs
                    v-model="editableTabsValue"
                    type="card"
                    @edit="handleTabsEdit"
                >
                    <el-tab-pane label="菜品信息" name="1">
                        <!--查询条件-->
                        <div class="searchTj">
                            <div class="searchTjHead">
                                <span>查询条件</span>
                                <i
                                    class="searchDomw"
                                    @click="showSearch = !showSearch"
                                    :class="
                                        showSearch == true
                                            ? 'el-icon-arrow-up'
                                            : 'el-icon-arrow-down'
                                    "
                                ></i>
                                <!-- <el-button
                  style="float: right; padding: 3px 0; color: #000"
                  type="text"
                  @click="Reset"
                >
                  <i class="el-icon-refresh"></i>
                  刷新页面
                </el-button> -->
                            </div>
                            <el-form
                                :model="form"
                                class="searchTjContent"
                                v-show="showSearch"
                            >
                                <div class="searchTjContentDiv">
                                    <span class="searchTjContentDivSpan"
                                        >菜品名称</span
                                    >
                                    <el-input
                                        v-model="form.foodName"
                                        placeholder="请输入"
                                        class="searchTjContentDivInput"
                                    ></el-input>
                                </div>
                                <div class="searchTjContentDiv" v-show="quanbu">
                                    <el-button
                                        type="primary"
                                        @click="query"
                                        icon="el-icon-search"
                                        size="medium"
                                        class="searchBtns"
                                        >查询</el-button
                                    >
                                </div>

                                <div class="searchTjContentDiv">
                                    <el-button
                                        type="info"
                                        @click="resert"
                                        icon="el-icon-delete"
                                        >清除条件</el-button
                                    >
                                </div>
                                <div class="arrowDown" @click="showSearch">
                                    <i
                                        class="el-icon-arrow-down"
                                        style="color: #000"
                                    ></i>
                                </div>
                            </el-form>
                        </div>

                        <!--按钮-->
                        <div class="searchButtonDiv" v-if="quanbu">
                            <div class="searchButtonDivLeft">
                                <el-button-group>
                                    <el-button
                                        icon="el-icon-plus"
                                        type="success"
                                        class="openBtns"
                                        @click="showDialog('新增')"
                                        >新增</el-button
                                    >
                                    <el-button
                                        icon="el-icon-delete"
                                        type="danger"
                                        @click="batchDelete"
                                        >批量删除</el-button
                                    >
                                </el-button-group>
                            </div>
                            <div class="searchButtonDiveRight">
                                <el-button-group>
                                    <el-button
                                        type="primary"
                                        icon="el-icon-refresh"
                                        class="dropRests"
                                        @click="resertTable"
                                    ></el-button>
                                    <!-- <el-button type="primary"> -->
                                    <el-dropdown
                                        class="dropdown"
                                        trigger="click"
                                        :hide-on-click="false"
                                    >
                                        <span class="el-dropdown-link">
                                            <i
                                                class="
                                                    el-icon-s-grid
                                                    el-icon--right
                                                "
                                                style="color: #fff"
                                            ></i>
                                            <i
                                                class="
                                                    el-icon-arrow-down
                                                    el-icon--right
                                                "
                                            ></i>
                                        </span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item>
                                                <template>
                                                    <el-checkbox-group
                                                        v-model="checkList"
                                                        :min="1"
                                                        @change="tableShow"
                                                    >
                                                        <el-checkbox
                                                            label="序号"
                                                            >序号</el-checkbox
                                                        ><br />
                                                        <el-checkbox
                                                            label="菜品名称"
                                                            >菜品名称</el-checkbox
                                                        ><br />
                                                        <el-checkbox
                                                            label="菜品价格"
                                                            >菜品价格</el-checkbox
                                                        ><br />
                                                        <el-checkbox
                                                            label="耗材"
                                                            >耗材</el-checkbox
                                                        ><br />
                                                        <el-checkbox
                                                            label="菜品口味"
                                                            >菜品口味</el-checkbox
                                                        ><br />
                                                        <el-checkbox
                                                            label="主厨"
                                                            >主厨</el-checkbox
                                                        ><br />
                                                        <el-checkbox
                                                            label="添加时间"
                                                            >添加时间</el-checkbox
                                                        ><br />
                                                        <el-checkbox
                                                            label="操作"
                                                            >操作</el-checkbox
                                                        ><br />
                                                    </el-checkbox-group>
                                                </template>
                                            </el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                    <!-- </el-button> -->
                                </el-button-group>
                            </div>
                        </div>

                        <!--表格-->
                        <div>
                            <el-table
                                ref="multipleTable"
                                :data="myData"
                                tooltip-effect="dark"
                                @row-click="openDetails"
                                highlight-current-row
                                @selection-change="handleSelectionChange"
                                :header-cell-style="{
                                    background: '#e6e6e6',
                                    color: '#000',
                                }"
                                border
                            >
                                <el-table-column
                                    type="selection"
                                    width="50"
                                    align="center"
                                    @selection-change="handleSelectionChange"
                                >
                                </el-table-column>
                                <el-table-column
                                    type="index"
                                    width="100"
                                    label="序号"
                                    header-align="center"
                                    align="center"
                                    v-if="no1"
                                ></el-table-column>
                                <el-table-column
                                    prop="foodName"
                                    label="菜品名称"
                                    align="center"
                                    v-if="no2"
                                    show-overflow-tooltip
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="foodPrice"
                                    label="菜品价格"
                                    align="center"
                                    show-overflow-tooltip
                                    v-if="no3"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="consumableNames"
                                    label="耗材"
                                    align="center"
                                    show-overflow-tooltip
                                    v-if="no4"
                                >
                                    <!-- <template slot-scope="scope">
                  {{scope.row.consumableList.consumableName}}
                </template> -->
                                </el-table-column>
                                <el-table-column
                                    prop="foodFlavour"
                                    label="菜品口味"
                                    width="190"
                                    align="center"
                                    show-overflow-tooltip
                                    v-if="no5"
                                >
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.foodFlavour == 1"
                                            >酸</span
                                        >
                                        <span v-if="scope.row.foodFlavour == 2"
                                            >甜</span
                                        >
                                        <span v-if="scope.row.foodFlavour == 3"
                                            >苦</span
                                        >
                                        <span v-if="scope.row.foodFlavour == 4"
                                            >辣</span
                                        >
                                        <span v-if="scope.row.foodFlavour == 5"
                                            >咸</span
                                        >
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    prop="personName"
                                    label="主厨"
                                    width="190"
                                    align="center"
                                    show-overflow-tooltip
                                    v-if="no6"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="createDate"
                                    label="添加时间"
                                    width="190"
                                    align="center"
                                    show-overflow-tooltip
                                    v-if="no7"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="operation"
                                    label="操作"
                                    align="center"
                                    width="230"
                                    v-if="no8"
                                >
                                    <template slot-scope="scope">
                                        <el-tooltip
                                            class="item"
                                            effect="dark"
                                            content="查看"
                                            placement="top-start"
                                        >
                                            <button
                                                style="color: #000"
                                                class="
                                                    iconfont
                                                    icon-chakan
                                                    tabBtn
                                                "
                                                @click="
                                                    showDialog(
                                                        '查看',
                                                        scope.row
                                                    )
                                                "
                                            ></button>
                                        </el-tooltip>
                                        <el-tooltip
                                            class="item"
                                            effect="dark"
                                            content="编辑"
                                            placement="top-start"
                                        >
                                            <button
                                                style="color: #000"
                                                class="
                                                    iconfont
                                                    icon-bianji3
                                                    tabBtn
                                                "
                                                @click="
                                                    showDialog(
                                                        '编辑',
                                                        scope.row
                                                    )
                                                "
                                            ></button>
                                        </el-tooltip>
                                        <el-tooltip
                                            class="item"
                                            effect="dark"
                                            content="删除"
                                            placement="top-start"
                                        >
                                            <button
                                                style="color: #000"
                                                class="
                                                    iconfont
                                                    icon-icon7
                                                    tabBtn
                                                "
                                                @click="deleteItem(scope.row)"
                                            ></button>
                                        </el-tooltip>
                                    </template>
                                </el-table-column>
                            </el-table>

                            <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="currentPage"
                                :page-sizes="[10, 20, 50, 100]"
                                :page-size="10"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="total"
                            ></el-pagination>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
        <el-dialog
            :title="dialogTile1"
            :visible.sync="visVisible1"
            width="990px"
        >
            <el-form
                ref="addform"
                :model="addform"
                :rules="addformRules"
                label-width="110px"
                size="mini"
            >
                <el-form-item label="菜品名称：" prop="foodName">
                    <el-input
                        v-model.trim="addform.foodName"
                        placeholder="请输入"
                        :disabled="dialogTile1 == '查看'"
                    ></el-input>
                </el-form-item>
                <el-form-item label="菜品价格：" prop="foodPrice">
                    <el-input
                        v-model.trim="addform.foodPrice"
                        placeholder="请输入"
                        onkeyup="value=value.replace(/[^0-9.]/g,'')"
                        :disabled="dialogTile1 == '查看'"
                        ><i slot="suffix">元</i></el-input
                    >
                </el-form-item>
                <el-form-item label="菜品口味：" prop="foodFlavour">
                    <el-select
                        :disabled="dialogTile1 == '查看'"
                        v-model="addform.foodFlavour"
                        placeholder=""
                        style="width: 100%"
                    >
                        <el-option
                            v-for="item in foodFlavours"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>

                <!-- <el-form-item label="组织机构：" style="height:40px" prop="orgName">
		  <el-select style="width: 100%;"
		             class="marginT34"
		             v-model="addform.orgName"
		             placeholder="请选择组织机构"
		             ref="selectBoxRef"
					 :disabled="dialogTile1 == '查看'"
		             >
		    <el-option :value="addform.orgName"
		               style="height: auto;">
		      <el-tree :data="orgList"
		               :props="defaultProps"
								 ref='tree'
		               @node-click="handleEditNodeClick"
		               class="tree_box"></el-tree>
		    </el-option>
		  </el-select>
		</el-form-item> -->

                <el-form-item label="耗材：" prop="consumableList">
                    <el-button
                        icon="el-icon-plus"
                        type="success"
                        :disabled="dialogTile1 == '查看'"
                        @click.native="addDialog('新增')"
                        style="margin-bottom: 10px"
                        >新增</el-button
                    >
                    <el-table
                        :data="addform.consumableList"
                        tooltip-effect="dark"
                        :header-cell-style="{
                            background: '#e6e6e6',
                            color: '#000',
                        }"
                        border
                    >
                        <el-table-column
                            type="index"
                            width="60"
                            label="序号"
                            header-align="center"
                            align="center"
                        ></el-table-column>
                        <el-table-column
                            prop="consumableName"
                            label="名称"
                            align="center"
                            show-overflow-tooltip
                        >
                        </el-table-column>
                        <!--            <el-table-column-->
                        <!--              prop="consumableSpecs"-->
                        <!--              label="规格"-->
                        <!--              align="center"-->
                        <!--              show-overflow-tooltip-->
                        <!--            >-->
                        <!--            </el-table-column>-->
                        <!--            <el-table-column-->
                        <!--              prop="consumableWeight"-->
                        <!--              label="重量(每千克)"-->
                        <!--              align="center"-->
                        <!--              width="150"-->
                        <!--              show-overflow-tooltip-->
                        <!--            >-->
                        <!--            </el-table-column>-->
                        <!--            <el-table-column-->
                        <!--              prop="consumableNum"-->
                        <!--              label="数量"-->
                        <!--              align="center"-->
                        <!--              width="150"-->
                        <!--              show-overflow-tooltip-->
                        <!--            >-->
                        <!--            </el-table-column>-->
                        <!-- <el-table-column label="操作" align="center" fixed="right">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="删除" placement="top-start" >
                  <img src="../assets/img/table_delete.png" @click="deleteItemOne(scope.row)"
                    style="margin-left: 12px; cursor: pointer"
                    />
                </el-tooltip>
              </template>
            </el-table-column> -->
                    </el-table>
                </el-form-item>
                <el-form-item
                    label="主厨："
                    style="margin-top: 20px"
                    prop="personId"
                >
                    <el-select
                        :disabled="dialogTile1 == '查看'"
                        v-model="addform.personId"
                        placeholder=""
                        style="width: 100%"
                    >
                        <el-option
                            v-for="item in cheflist"
                            :key="item.id"
                            :label="item.personName"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                    <!-- <el-input
            :disabled="dialogTile1 == '查看'"
            v-model="addform.personId"
            placeholder="请输入"
          ></el-input> -->
                </el-form-item>
            </el-form>
            <div slot="footer" v-if="dialogTile1 != '查看'">
                <el-button
                    type="primary"
                    size="small"
                    style="margin: 0 30px"
                    @click="saveadddata"
                    >保存
                </el-button>
                <el-button type="info" size="small" @click="clearadddata"
                    >关闭</el-button
                >
            </div>
        </el-dialog>

        <el-dialog
            title="原料列表"
            :visible.sync="visVisible"
            :modal-append-to-body="true"
            :append-to-body="true"
            width="600px"
        >
            <el-form
                ref="typeForm"
                :model="typeForm"
                :rules="typeRules"
                label-width="110px"
                size="mini"
            >
                <el-form-item label="名称:" prop="foodId">
                    <el-select
                        v-model="typeForm.foodId"
                        placeholder="请选择"
                        style="width: 100%"
                        filterable
                    >
                        <el-option
                            v-for="(item, index) in datelist"
                            :key="index"
                            :label="item.materialName"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <!--        <el-form-item label="规格:" prop="consumableSpecs">-->
                <!--          <el-input-->
                <!--            v-model.trim="typeForm.consumableSpecs"-->
                <!--            placeholder="请输入"-->
                <!--          ></el-input>-->
                <!--        </el-form-item>-->
                <!--         <el-form-item label="重量(每千克):" prop="consumableWeight">-->
                <!--          <el-input-->
                <!--            v-model="typeForm.consumableWeight"-->
                <!--            type='number'-->
                <!--            placeholder="请输入"-->
                <!--          ></el-input>-->
                <!--        </el-form-item>-->
                <!--        <el-form-item label="数量:" prop="consumableNum">-->
                <!--          <el-input-->
                <!--            v-model.trim="typeForm.consumableNum"-->
                <!--            placeholder="请输入"-->
                <!--          ></el-input>-->
                <!--        </el-form-item>-->
            </el-form>
            <div slot="footer">
                <el-button
                    type="primary"
                    size="small"
                    style="margin: 0 30px"
                    @click="typeList"
                    >保存
                </el-button>
                <el-button type="info" size="small" @click="visVisible = false"
                    >关闭</el-button
                >
            </div>
        </el-dialog>
    </div>
</template>
<script>
import common from "../../../utils/common.js"
import request from "@/utils/request.js"
import { conflictMediationApi2 } from "@/api/http.js"
import request2 from "@/utils/request2.js"
import { post, get } from "@/api/requrestHttp.js"

export default {
    data() {
        return {
            defaultProps: {
                children: "children",
                label: "label",
            },
            orgLevels: "",
            orgList: [],
            arrOrgList: [],
            // 表单验证
            addformRules: {
                foodName: [
                    {
                        required: true,
                        message: "请输入菜品名称",
                        trigger: "blur",
                    },
                ],
                // orgName: [{ required: true, message: "请选择组织机构", trigger: "change" }],
                foodPrice: [
                    {
                        required: true,
                        message: "请输入菜品价格",
                        trigger: "blur",
                    },
                ],
                // personId: [{ required: true, message: "请输入主厨", trigger: "blur" }],
            },
            typeRules: {
                foodId: [
                    {
                        required: true,
                        message: "请选择材料名称",
                        trigger: "change",
                    },
                ],
                consumableSpecs: [
                    { required: true, message: "请输入规格", trigger: "blur" },
                ],
                consumableNum: [
                    { required: true, message: "请输入数量", trigger: "blur" },
                ],
                consumableWeight: [
                    { required: true, message: "请输入重量", trigger: "blur" },
                ],
            },
            selectedData: [],
            foodlist: [],
            // 材料选择
            datelist: [],
            typeForm: {
                foodId: "",
                consumableSpecs: "",
                consumableNum: "",
            },
            // 图片地址
            actionUrl: "",
            visVisible: false,
            visVisible1: false,
            disabled: false,
            dialogTile1: "",
            // 图片
            photo: [],
            addform: {
                qujiId: "",
                shijiid: "",
                stationId: "",
                shengjiId: "",
                orgId: "",
                // orgName: ''
                // consumableList: [],
            },
            checkList: [
                "序号",
                "菜品名称",
                "菜品价格",
                "耗材",
                "菜品口味",
                "主厨",
                "添加时间",
                "操作",
            ],
            quanbu: true,
            // 新增模态框口味
            foodFlavours: [
                {
                    value: "1",
                    label: "酸",
                },
                {
                    value: "2",
                    label: "甜",
                },
                {
                    value: "3",
                    label: "苦",
                },
                {
                    value: "4",
                    label: "辣",
                },
                {
                    value: "5",
                    label: "咸",
                },
            ],

            currentPage: 1, //默认展示第一页
            total: 0, //总数据
            timer: "", //定义一个定时器的变量
            showSearch: true,
            editableTabsValue: "1",
            hcai: [],
            myData: [],
            myFood: [],
            pageNo: 1,
            pageSize: 10,
            pageConfig: {
                pageSize: 10,
                total: 0,
                pageNo: 1,
            },
            form: {
                personName: "",
                idCode: "",
                linkPhone: "",
                gridCode: "",
                pageNo: 1,
                pageSize: 10,
            },
            dialogTile: "",
            dialogImageUrl: "",
            dialogVisible1: false,
            // 主厨列表
            cheflist: [],
            // 列表显示
            no1: true,
            no2: true,
            no3: true,
            no4: true,
            no5: true,
            no6: true,
            no7: true,
            no8: true,
        }
    },
    inject: ["reload"], //注入
    methods: {
        loopNode(node, arr) {
            if (node.parent == null) {
                return arr
            } else {
                arr.push(node.data.orgId)
                this.loopNode(node.parent, arr)
            }
        },
        handleEditNodeClick(data, node) {
            const clickNode = this.$refs.tree.getNode(node)
            const arr = []
            this.loopNode(clickNode, arr)
            this.arrOrgList = arr
            let obj = common.organization(this.arrOrgList, this.orgLevels)
            this.$set(this.addform, "orgId", data.orgId)
            this.$set(this.addform, "parentId", data.parentId)
            this.$set(this.addform, "orgType", data.orgType)
            // this.$set(this.addform, "orgName", data.label);

            this.$set(this.addform, "qujiId", obj.qujiId)
            this.$set(this.addform, "shengjiId", obj.shengjiId)
            this.$set(this.addform, "shijiId", obj.shijiId)
            this.$set(this.addform, "stationId", obj.stationId)
            this.$set(this.addform, "shequjiId", obj.shequjiId)
            this.$refs["selectBoxRef"].handleClose()
        },
        //获取组织机构
        getOrg() {
            this.$http
                .request({
                    url: "/rbac/admin/org/info/OrgTreelist",
                    method: "POST",
                    data: {},
                })
                .then((res) => {
                    if (res.code == 200) {
                        for (let i in res.content) {
                            if (res.content[i].orgType == "1") {
                                this.orgList.push(res.content[i])
                            }
                            this.orgLevels = res.content[0].orgLevel
                        }
                    }
                })
        },

        //删除耗材
        // deleteItemOne(row){
        //   console.log(row)
        //   this.$confirm("确认永久删除吗?", "提示", {
        //     confirmButtonText: "确定",
        //     cancelButtonText: "取消",
        //     type: "warning",
        //   }).then(() => {
        //     console.log(this.addform.consumableList)
        //     // this.addform.consumableList = this.addtableData.filter(item => item.volunteerArchiveCode != row.volunteerArchiveCode)
        //     // this.total1 = this.addtableData.length
        //     // this.$message.success('删除成功')
        //   }).catch(() => {
        //     this.$message({
        //       type: 'info',
        //       message: '已取消删除'
        //     })
        //   })
        // },

        // 列表项显示
        tableShow() {
            if (this.checkList.length > 0) {
                if (this.checkList.findIndex((obj) => obj == "序号") == -1) {
                    this.no1 = false
                } else {
                    this.no1 = true
                }
                if (
                    this.checkList.findIndex((obj) => obj == "菜品名称") == -1
                ) {
                    this.no2 = false
                } else {
                    this.no2 = true
                }
                if (
                    this.checkList.findIndex((obj) => obj == "菜品价格") == -1
                ) {
                    this.no3 = false
                } else {
                    this.no3 = true
                }
                if (this.checkList.findIndex((obj) => obj == "耗材") == -1) {
                    this.no4 = false
                } else {
                    this.no4 = true
                }
                if (
                    this.checkList.findIndex((obj) => obj == "菜品口味") == -1
                ) {
                    this.no5 = false
                } else {
                    this.no5 = true
                }
                if (this.checkList.findIndex((obj) => obj == "主厨") == -1) {
                    this.no6 = false
                } else {
                    this.no6 = true
                }
                if (
                    this.checkList.findIndex((obj) => obj == "添加时间") == -1
                ) {
                    this.no7 = false
                } else {
                    this.no7 = true
                }
                if (this.checkList.findIndex((obj) => obj == "操作") == -1) {
                    this.no8 = false
                } else {
                    this.no8 = true
                }
            }
        },
        // 新增
        showDialog(type, data) {
            this.visVisible1 = true
            this.dialogTile1 = type
            this.resetForm("addform")
            this.chef()
            switch (type) {
                case "新增":
                    this.addform = {}
                    break
                case "查看":
                    this.look(data)
                    this.disabled = true
                    break
                case "编辑":
                    this.look(data)
                    this.disabled = false
                    break
            }
        },
        // 弹框内新增
        addDialog() {
            this.resetForm("typeForm")
            this.visVisible = true
        },
        clearadddata() {
            this.visVisible = false
            this.visVisible1 = false
        },
        // 新增,修改保存
        saveadddata() {
            // if(this.addform.consumableList==undefined){
            // this.$message.error("请添加材料")
            // return false
            // }else{
            this.$refs.addform.validate((valid) => {
                if (valid) {
                    if (this.addform.id == undefined) {
                        request({
                            url: "/sqyl/admin/food/info/insert",
                            method: "POST",
                            data: {
                                pageNo: this.pageNo,
                                pageSize: this.pageSize,
                                ...this.addform,
                                qujiId: JSON.parse(
                                    localStorage.getItem("czUserInfo")
                                ).qujiId,
                                shengjiId: JSON.parse(
                                    localStorage.getItem("czUserInfo")
                                ).shengjiId,
                                shijiId: JSON.parse(
                                    localStorage.getItem("czUserInfo")
                                ).shijiId,
                                stationId: JSON.parse(
                                    localStorage.getItem("czUserInfo")
                                ).stationId,
                                shequjiId: JSON.parse(
                                    localStorage.getItem("czUserInfo")
                                ).shequjiId,
                            },
                        }).then((res) => {
                            // console.log(res);
                            if (res.code == 200) {
                                this.showlist()
                            }
                        })
                        this.addform = {}
                        this.visVisible1 = false
                    } else {
                        request({
                            url: "/sqyl/admin/food/info/update",
                            method: "POST",
                            data: {
                                pageNo: this.pageNo,
                                pageSize: this.pageSize,
                                ...this.addform,
                            },
                        }).then((res) => {
                            // console.log(res);
                            if (res.code == 200) {
                                this.showlist()
                            }
                        })
                        this.addform = {}
                        this.visVisible1 = false
                    }
                }
            })
            //}
        },

        // 查看
        look(date) {
            let params = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                id: date.id,
            }
            params = Object.assign({}, params)
            request({
                url: "/sqyl/admin/food/info/findById",
                method: "POST",
                data: params,
            }).then((res) => {
                // console.log(res);
                // this.pageConfig.total = res.content.count;
                this.addform = res.content
                this.addform.consumableList = res.content.consumableList
                // this.total = res.content.count;
            })
        },
        // 删除
        deleteItem(date) {
            let params = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                id: date.id,
            }
            params = Object.assign({}, params)
            this.$confirm("确认永久删除吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                request({
                    url: "/sqyl/admin/food/info/deleteById",
                    method: "POST",
                    data: params,
                }).then((res) => {
                    // console.log(res);
                    if (res.code == 200) {
                        this.showlist()
                        this.visVisible1 = false
                    }
                })
            })
        },
        // 条件重置
        // 重置
        resert() {
            this.form = {}
            this.showlist()
        },

        //每页请求数据
        handleSizeChange(val) {
            this.pageSize = val
            this.showlist()
            this.$message({
                message: `每页请求${val}条数据成功`,
                type: "success",
            })
        },
        //请求第几数据
        handleCurrentChange(val) {
            this.pageNo = val
            this.showlist()
            this.$message({
                message: `请求第${val}页数据成功`,
                type: "success",
            })
        },
        typeList(val) {
            var consumableNameId = ""
            let obj = { ...this.typeForm }
            this.hcai.push(obj)
            this.hcai.forEach((item, index1) => {
                this.hcai[index1].consumableNameId = this.hcai[index1].foodId
                this.datelist.forEach((child, index) => {
                    if (item.foodId == child.id) {
                        item.consumableName = child.materialName
                    }
                })
            })

            this.$set(this.addform, "consumableList", this.hcai)
            this.typeForm.foodId = ""
            this.typeForm.consumableSpecs = ""
            this.typeForm.consumableNum = ""
            this.visVisible = false
        },
        // 行点击选中
        openDetails(row, event, column, cell) {
            this.$refs.multipleTable.toggleRowSelection(row)
            this.showtext = !this.showtext
            this.row = row
            this.column = column
        },
        handleSelectionChange(data) {
            this.selectedData = data
        },
        batchDelete() {
            var that = this
            var val = this.selectedData
            if (val.length > 0) {
                this.$confirm("确认永久删除吗?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        val.forEach(function (item, index) {
                            request({
                                url: "/sqyl/admin/food/info/deleteById",
                                method: "POST",
                                data: { id: item.id },
                            })
                        })
                    })
                    .then(() => {
                        this.showlist()
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        })
                    })
            } else {
                this.$confirm("请选择要删除的项。", "提示")
            }
            this.$refs.multipleTable.clearSelection()
        },

        handleClose(key, keyPath) {
            console.log(key, keyPath)
        },
        handleTabsEdit(targetName, action) {
            this.showlist(e)
        },
        //拿到列表数据
        async showlist(e) {
            let params = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                qujiId: JSON.parse(localStorage.getItem("czUserInfo")).qujiId,
                shengjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shengjiId,
                shijiId: JSON.parse(localStorage.getItem("czUserInfo")).shijiId,
                stationId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .stationId,
                shequjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shequjiId,
            }
            params = Object.assign({}, params, {
                ...e,
            })
            await request({
                url: "/sqyl/admin/food/info/findList",
                method: "POST",
                data: params,
            }).then((res) => {
                console.log(res)
                if (res.content != null) {
                    // this.pageConfig.total = res.content.count;
                    this.myData = res.content.list
                    this.total = res.content.count
                } else {
                    this.myData = []
                }
            })
        },

        // 查询
        query() {
            post("/sqyl/admin/food/info/findList", {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                qujiId: JSON.parse(localStorage.getItem("czUserInfo")).qujiId,
                shengjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shengjiId,
                shijiId: JSON.parse(localStorage.getItem("czUserInfo")).shijiId,
                stationId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .stationId,
                shequjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shequjiId,
                ...this.form,
            }).then((res) => {
                if (res.content != null) {
                    this.myData = res.content.list
                    this.total = res.content.count
                } else {
                    this.myData = []
                }
            })
        },
        // 重置
        Reset() {
            this.reload()
        },

        // 表单重置
        resetForm(formName) {
            if (this.$refs[formName] !== undefined) {
                this.$refs[formName].resetFields()
            }
        },

        // 预览图片
        handlePicturePreview(file) {
            this.dialogVisible1 = true
            this.dialogImageUrl = file.url
        },

        // 材料名称接口
        list() {
            let params = {
                pageNo: 1,
                pageSize: -1,
            }
            params = Object.assign({}, params)
            request({
                url: "/sqyl/admin/material/info/findList",
                method: "POST",
                data: params,
            }).then((res) => {
                // console.log(res);
                this.datelist = res.content.list
            })
        },

        // 表单刷新
        resertTable() {
            this.showlist()
            this.checkList = [
                "序号",
                "菜品名称",
                "菜品价格",
                "耗材",
                "菜品口味",
                "主厨",
                "添加时间",
                "操作",
            ]
            this.tableShow()
        },
        // 主厨
        async chef() {
            let params = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                personPosition: 5,
            }
            await request({
                url: "/sqyl/admin/person/info/findByPosition",
                method: "POST",
                data: params,
            }).then((res) => {
                console.log(res)
                this.cheflist = res.content
            })
        },
    },
    created() {
        this.getOrg()
        this.showlist()
        this.list()
    },
}
</script>
<style lang="less" scoped>
.rkld {
    display: flex;
    flex-direction: row;
    height: 100vh;
    overflow: hidden;
}

.rkldRight {
    flex: 1;
    height: 100%;
    width: calc(100% - 254px);
    background-color: #ffffff;
}

.rkldRightHeadRight {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: 15px;
}

.demo-form-inline {
    padding: 0 5%;
}

.btnform {
    text-align: center;
}

.rkldRightHeadRightRight {
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;
    cursor: pointer;
    background: rgba(252, 254, 255, 1);
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 19px;
    box-sizing: border-box;
    padding: 7px 20px;
    margin-left: 20px;
    color: #444;
    font-size: 12px;
}

.rkldRightHeadRightRight span {
    width: 1px;
    height: 20px;
    margin: 0 14px;
    background: #ccc;
    opacity: 0.6;
}

.rkldRightHeadRightRight div {
    display: flex;
    align-items: center;
}
.rkldRightContent {
    height: calc(100% - 70px);
    overflow-y: auto;
    margin: 20px;
}

.searchTj {
    display: flex;
    flex-direction: column;
    position: relative;
    background: #f1f2f6;
    box-shadow: 0 0 6px rgba(151, 151, 151, 0.16);
    overflow: hidden;
    border-radius: 4px;
    margin: 5px;
}

.searchTjHead {
    background: #fff;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    color: rgb(0, 0, 0);
    border-color: rgb(217, 217, 217);
    padding: 6px 15px;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
}

.searchTjContent {
    padding: 15px 20px 0px 5px;
    border: 1px solid rgb(217, 217, 217);
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}

.searchTjContentDiv {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 40px;
    margin-bottom: 10px;

    .el-button {
        border-radius: 4px;
    }
}

.searchTjContentDivSpan {
    min-width: 58px;
    margin-right: 20px;
    font-size: 14px;
}

.searchTjContentDivInput {
    width: 20%;
    min-width: 196px;
}

/deep/ .arrowDown {
    width: 28px;
    height: 28px;
    background: #edf2f0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 50%;
    bottom: -14px;
    transform: translate(-50%, 0px);
    border-radius: 50%;
    z-index: 2;
    cursor: pointer;
}

/deep/ .el-tabs__content {
    padding-bottom: 20px;
}

.searchButtonDiv {
    height: 54px;
    display: flex;
    margin-top: 14px;
    align-items: center;
    justify-content: space-between;
}

.searchButtonDivLeft {
    display: flex;
}

/deep/ .el-button {
    margin-left: 0px;
    border-radius: 0px;
    padding: 0px 8px !important;
    border: none;
    height: 30px;
}

.el-button-group /deep/ .el-button--warning:last-child {
    border-left-color: rgba(255, 255, 255, 0.5);
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}

/deep/ .el-pagination {
    margin-top: 10px;
}

/deep/ .el-submenu__title i {
    color: #fff;
}

/deep/ .el-submenu__title {
    border-bottom: 1px solid #2c3342;
    background: rgb(55, 64, 79) !important;
}

/deep/ .el-submenu.is-active /deep/ .el-submenu__title {
    border-bottom: 1px solid rgb(55, 64, 79);
}

/deep/
    .el-tabs--card
    > .el-tabs__header
    /deep/
    .el-tabs__item.is-active.is-closable {
    color: #0e2d5f;
}

/deep/ .el-submenu {
    width: 234px !important;
}

/deep/ .tabBtn {
    margin: 0px;
}

.boontbtn {
    margin-top: 30px;
    display: flex;
    justify-content: center;
}
.searchButtonDivLeft {
    /deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
        color: #000000;
    }

    /deep/.el-button:first-of-type {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
    }
    /deep/.el-button:last-of-type {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        i,
        span {
            color: #fff;
        }
    }
}

/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #000000;
}

/* 用来设置当前页面element全局table 选中某行时的背景色*/
/deep/ .el-table__body tr.current-row > td {
    background-color: #fafad2 !important;
    color: #000;
}
/deep/ .el-table tbody tr:hover > td {
    background-color: #fafad2 !important;
}

/deep/ .el-dialog .el-dialog__header {
    border-bottom: 1px solid #e4e4e4;
}
// 弹框底部
/deep/ .el-dialog .el-dialog__footer {
    background-color: #f5f5f5;
}
</style>
